import NotificationDispatcher from "../core/notification-dispatcher/NotificationDispatcher";
import { NumberishId } from "../model/type";
import MediumAvailabilitiesDao from "../infrastructure/dao/MediumAvailabilitiesDao";

const acceptOrRejectMediumAvailability = (dao: MediumAvailabilitiesDao, notificationDispatcher: NotificationDispatcher): AcceptOrRejectMediumAvailability => (mediumAvailabilityId, accepted) => {
    return dao.acceptOrReject(mediumAvailabilityId, accepted);
}
export default acceptOrRejectMediumAvailability;

export type AcceptOrRejectMediumAvailability = (mediumAvailabilityId: NumberishId, accepted: boolean) => Promise<any>;